import "./App.css";
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import Home from "./pages/Home.jsx";
import Chat from "./pages/chat";
import AuthPage from "./pages/AuthPage";
import Chat2 from "./pages/chat2";
import Contact from "./pages/contact";
import TypewriterComponent from "typewriter-effect";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./ScrollToTop";
import React, { useEffect } from 'react';
import AIShowcase from "./pages/AIShowcase";
import SearchForm from "./pages/SearchForm";
import Navbar from "./components/Navbar";
import LoginModal from "./components/LoginModal.jsx";
import { AuthProvider } from "./context/AuthContext";
import BookFlight from "./pages/BookFlight";
import Test from "./pages/test";
import TestPayment from "./components/testBooking/testPayment";
import FlightBooking from "./pages/FligthBooking";
import BusBooking from "./pages/BusBooking"
import TestComponents from "./pages/TestComponents";
import BookingHistory from "./pages/BookingHistory";
import BookingDetail from "./pages/BookingDetail";
import Home2 from "./pages/home2.jsx";
import SharedMapPage from "./pages/SharedMapPage";
import TripPlanner from "./TripPlanner";
import TripShare from "./TripShare";
import HotelBookingPage from "./pages/HotelBookingPage";
import HowToReach from "./pages/HowToReach";
import HowToReachIndex from "./pages/HowToReachIndex";
import ShortLinkResolver from "./pages/ShortLinkResolver";

import BusBookingPage from './pages/BusBookingPage'; // adjust path
import BusBookingConfirmationPage from "./pages/BusBookingConfirmationPage";



const Layout = ({ children }) => {
  const location = useLocation();
  // Exclude Navbar from these paths
  const excludeNavbarPaths = ["/auth", "/search-form", "/r", "/shared-route", "/trip-planner", "/trip-share"];
  const shouldShowNavbar = !excludeNavbarPaths.some(path =>
    location.pathname === path ||
    location.pathname.startsWith(path + "/") ||
    (path === "/r" && location.pathname.startsWith("/r"))
  );

  return (
    <>
      <ScrollToTop />
      {shouldShowNavbar && <Navbar />}
      {children}
      <LoginModal />
    </>
  );
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // ESC closes auth route
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape" && location.pathname === "/auth") {
        navigate("/", { replace: true });
      }
    };
    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (!window.gtagScriptLoaded) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-LYGBCY5BKH";
      document.head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "G-LYGBCY5BKH");
      window.gtagScriptLoaded = true;
    }
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-LYGBCY5BKH", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <AuthProvider>
      <Layout>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Home2 />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/typetest" element={<TypewriterComponent />} />
          <Route path="/ai-test" element={<AIShowcase />} />
          <Route path="/search-form/:status?" element={<SearchForm />} />
          <Route path="/home.html" element={<Navigate to="/" />} />
          <Route path="/home" element={<Navigate to="/" />} />

          <Route path="/book-flight" element={<BookFlight />} />
          <Route path="/booking-flight" element={<FlightBooking />} />
          <Route path="/booking-history" element={<BookingHistory />} />
          <Route path="/booking-detail" element={<BookingDetail />} />

          <Route path="/test" element={<Test />} />
          <Route path="/test/components" element={<TestComponents />} />
          <Route path="/test-payment" element={<TestPayment />} />
          <Route path="/book-bus/status" element={<BusBooking />} />

          {/* Shared Map Dynamic Route */}
          <Route path="/shared-route" element={<SharedMapPage />} />

          {/* Short shared-route links — resolved in-app (no CloudFront redirect,
              so long rdata URLs can never 414). /b/ booking links stay on the
              CloudFront redirect path untouched. */}
          <Route path="/r/:code" element={<ShortLinkResolver />} />

          {/* SEO corridor pages ("How to reach X from Y") */}
          <Route path="/how-to-reach/:slug" element={<HowToReach />} />
          <Route path="/how-to-reach" element={<HowToReachIndex />} />

          {/* AI Trip Planner */}
          <Route path="/trip-planner" element={<TripPlanner />} />
          <Route path="/trip-planner/hotel/:hotelCode" element={<HotelBookingPage />} />
          <Route path="/trip-share" element={<TripShare />} />
          <Route path="/book-bus" element={<BusBookingPage />} />
          <Route path="/book-bus/confirmation" element={<BusBookingConfirmationPage />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}

export default App;
